const APP_NAMESPACE = 'matcher-store'

/**
 * Create the functions to interact with the local storage but namespaced with
 * the given string to avoid conflicts with other modules.
 *
 * @param {String} namespace
 */
export function createNamespacedLocalStorageFunctions(namespace) {
  /**
   * Format the given key to add the app namespace and the given namespace.
   *
   * @param {String} key
   */
  function format(key) {
    return `${APP_NAMESPACE}/${namespace}/${key}`
  }

  return {
    setItem(key, value) {
      return window.localStorage.setItem(format(key), value);
    },
    getItem(key) {
      return window.localStorage.getItem(format(key));
    },
    removeItem(key) {
      return window.localStorage.removeItem(format(key));
    }
  }
}

export default createNamespacedLocalStorageFunctions
